import type { ReactNode } from 'react';
import React, { useContext } from 'react';
import { t } from 'Src/i18n';
import { tAlt } from 'Components/utils/booking/bookingUtils';
import { ICONS } from 'Components/utils/icon/icons';
import { ID_LAYER_HEADER__BE__ACCOMMODATIONS } from 'Components/utils/identifiers/constants';
import { TRACK_PAGE_NAMES } from 'Tracking/constants';
import { TrackPage } from 'Tracking/track-page/TrackPage';
import { BookingEngineTrackingContext } from 'Views/booking/BookingEngineTrackingContext';
import { AdditionalAccommodations } from 'Components/widgets/additional-accommodations/AdditionalAccommodations';
import { Layer } from 'Components/frameworks/layer/Layer';
import { LayerHeaderProposal } from 'Components/widgets/layer-header-proposal/LayerHeaderProposal';
export type AdditionalAccommodationsLayerProps = {
  children?: ReactNode;
  filters: Array<FilterItem>;
  filterValues: Array<Filter>;
  onClose: () => void;
  onSubmit: (arg0: string | AccommodationArrangement) => void;
  portalName?: string;
  processChangeAccommodation?: boolean;
  product: ProductWithAccommodations;
  proposal: Proposal;
  selectedRate: string;
  setSelectedRate: (arg0: string) => void;
  streetViews?: Array<StreetViewWithAccommodationCategoryId>;
  switchOffers: (offers: Array<string>) => void;
};
export const AdditionalAccommodationsLayer = ({
  children,
  filters,
  filterValues,
  onClose,
  onSubmit,
  portalName,
  processChangeAccommodation = true,
  product,
  proposal,
  selectedRate,
  setSelectedRate,
  streetViews,
  switchOffers,
}: AdditionalAccommodationsLayerProps) => {
  const beEngineTrackingContext = useContext(BookingEngineTrackingContext);
  const layerTitle = tAlt({
    cruiseKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitleCruise',
    product,
    resortKeyPath: 'booking.accommodation.moreRooms.modifyHeaderTitle',
  });
  return (
    <Layer
      ariaLabel={layerTitle}
      ariaLabelledby={ID_LAYER_HEADER__BE__ACCOMMODATIONS}
      buttonLeft={{
        iconName: ICONS.ARROW_TAIL_LEFT,
        label: t('common.backNavigation'),
        onClick: onClose,
      }}
      closeLabel={t('common.close')}
      hasContainerHeader
      header={
        <LayerHeaderProposal
          id={ID_LAYER_HEADER__BE__ACCOMMODATIONS}
          layerTitle={layerTitle}
          proposal={proposal}
          totalPrice={t('booking.accommodation.moreRooms.totalPackagePriceLabel')}
        />
      }
      onClose={onClose}
      portalName={portalName}
    >
      <TrackPage
        pageName={TRACK_PAGE_NAMES.BE_LAYER_ACCOMMODATION}
        payload={{ ...(beEngineTrackingContext as TrackPayload) }}
      />
      {children}
      <AdditionalAccommodations
        filters={filters}
        filterValues={filterValues}
        loaderClassName="mt-[10vh]"
        onClose={onClose}
        onSubmit={onSubmit}
        processChangeAccommodation={processChangeAccommodation}
        proposal={proposal}
        product={product}
        selectedRate={selectedRate}
        setSelectedRate={setSelectedRate}
        streetViews={streetViews}
        switchOffers={switchOffers}
      />
    </Layer>
  );
};
